import ApiBase from '@/services/ApiBase';
import { API_URL, getApiUrl } from '@/utils/api';
import { lastValueFrom } from 'rxjs';

export default class StorageService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.USER, '/storage');
  private baseUrl2 = getApiUrl(API_URL.USER, '/storage');
  static baseUrlStorageOrder = getApiUrl(API_URL.USER, '/storageOrder');

  getStorage(filter) {
    const filterParam = (new URLSearchParams({ filter })).toString();
    return this.api.getJSON(`${StorageService.baseUrl}${filter ? `?${filterParam}` : ''}`);
  }

  getStorageForWineBox(filter) {
    const filterParam = (new URLSearchParams({ filter })).toString();
    return this.api.getJSON(`${StorageService.baseUrl}/wineBox${filter ? `?${filterParam}` : ''}`);
  }

  getStorageHistory(status) {
    const statusParam = (new URLSearchParams({ status })).toString();
    return this.api.getJSON(`${StorageService.baseUrl}/history${status ? `?${statusParam}` : ''}`);
  }

  getCartStorage() {
    return this.api.getJSON(`${StorageService.baseUrl}/cartStorage`);
  }

  updateCartStorage(cartStorageItem) {
    return this.api.postJSON(`${StorageService.baseUrl}/cartStorage/addStorageProduct`, cartStorageItem);
  }

  getStorageOrderByOrderId(orderId: string) {
    return this.api.getJSON(`${StorageService.baseUrlStorageOrder}/getStorageOrderByOrderId/${orderId}`);
  }

  addItemToStorageWB(itemId: string, quantity: number) {
    return this.api.postJSON(`${StorageService.baseUrl}/wineBoxStorage/addStorageItem`, { itemId, quantity });
  }

  deleteStorageWB(wineBoxStorageId: string) {
    return this.api.deleteJSON(`${StorageService.baseUrl}/wineBoxStorage`, { wineBoxStorageId });
  }

  addStorageWineBoxToCart(wineBoxStorageId: string) {
    return this.api.postJSON(`${StorageService.baseUrl}/wineBoxStorage`, { wineBoxStorageId });
  }

  getDashboardStats() {
    return this.api.getJSON(`${StorageService.baseUrl}/dashboard`);
  }

  async exportStorage() {
    return lastValueFrom(this.api.getTextCSV(`${StorageService.baseUrl}/export`, { textCSV: true }));
  }

  resetCartStorage() {
    return this.api.getJSON(`${StorageService.baseUrl}/resetCartStorage`);
  }

  checkSignStatus() {
    return lastValueFrom(this.api.getJSON(`${StorageService.baseUrl}/signStatus`));
  }

  sendSignatureContract(pickIds: string[]) {
    return this.api.postPromisedJSON(`${StorageService.baseUrl}/sendSignatureContract`, { pickIds });
  }

  getLinkForDownloadContract(storeId: string, documentId: string, signatureRequestId: string): string {
    return `${this.baseUrl2}/downloadContract?storeId=${storeId}&document=${documentId}&signature=${signatureRequestId}`;
  }
}
